import { Box, Divider, FormField, Text, ToggleSwitch } from '@wix/design-system';
import React from 'react';

import { Link_Target } from './../../../../ricos-schema/legacy/wix/rich_content/v1';

import {
  ATTRIBUTES_NEW_TAB,
  ATTRIBUTES_NOFOLLOW,
  ATTRIBUTES_NOREFERRER,
  ATTRIBUTES_SPONSORED,
} from '../../data-hooks/data-hooks';
import type { AttributesProps } from '../types';
import { useAttributes } from './use-attributes';

export const AttributesMobile: React.FC<AttributesProps> = ({ link, onChange, t }) => {
  const { onToggleNewTab, onToggleNofollow, onToggleNoreferrer, onToggleSponsored } = useAttributes(
    link,
    onChange
  );

  return (
    <Box direction="vertical" gap="SP3">
      <FormField
        label={t('LinkSettings_Settings_NewTab_Label')}
        labelPlacement="left"
        labelWidth="1fr"
      >
        <ToggleSwitch
          checked={link.target === Link_Target.BLANK}
          dataHook={ATTRIBUTES_NEW_TAB}
          onChange={onToggleNewTab}
          size="small"
        />
      </FormField>
      <Divider />
      <Box direction="vertical" gap="SP1">
        <FormField
          label={t('LinkSettings_Settings_Noreferrer_Label')}
          labelPlacement="left"
          labelWidth="1fr"
        >
          <ToggleSwitch
            checked={link.rel?.noreferrer}
            dataHook={ATTRIBUTES_NOREFERRER}
            onChange={onToggleNoreferrer}
            size="small"
          />
        </FormField>
        <Text skin="disabled">{t('LinkSettings_Settings_Noreferrer_Tooltip')}</Text>
      </Box>
      <Divider />
      <Box direction="vertical" gap="SP1">
        <FormField
          label={t('LinkSettings_Settings_Nofollow_Label')}
          labelPlacement="left"
          labelWidth="1fr"
        >
          <ToggleSwitch
            checked={link.rel?.nofollow}
            dataHook={ATTRIBUTES_NOFOLLOW}
            onChange={onToggleNofollow}
            size="small"
          />
        </FormField>
        <Text skin="disabled">{t('LinkSettings_Settings_Nofollow_Tooltip')}</Text>
      </Box>
      <Divider />
      <Box direction="vertical" gap="SP1">
        <FormField
          label={t('LinkSettings_Settings_Sponsored_Label')}
          labelPlacement="left"
          labelWidth="1fr"
        >
          <ToggleSwitch
            checked={link.rel?.sponsored}
            dataHook={ATTRIBUTES_SPONSORED}
            onChange={onToggleSponsored}
            size="small"
          />
        </FormField>
        <Text skin="disabled">{t('LinkSettings_Settings_Sponsored_Tooltip')}</Text>
      </Box>
    </Box>
  );
};
